import { gql } from "@apollo/client";

export const CREDIT_FRAGMENT = gql`
  fragment CreditFields on CreditType {
    remittanceId
    checkNumber
    checkDate
    remittanceItemId
    invoiceNumber
    invoiceDate
    purchaser {
      purchaserId
      purchaserKey
      purchaserName
    }
    grossAmount
    netAmount
    discountAmount
    voucherNumber
    poNumber
    description
    documents {
      id
      fileName
      filePath
      fileSize
      createdAt
      updatedAt
      documentType
      documentTypeKey
      fileMimeType
      fileDisplayName
      deletable
    }
    remittanceItemCreatedAt
    remittanceItemUpdatedAt
    remittanceItemLastUpdatedAt
    isManuallyUploaded
  }
`;
